<script setup lang="ts">
import { ref } from "vue";
const editing = ref(false);
function set(value: boolean) {
  editing.value = value;
}
</script>
<template>
  <slot :set="set" :editing="editing" />
</template>
